type AOA = any[][];

export async function onFileReaderLoad(event: ProgressEvent<FileReader>): Promise<string[]> {
  const XLSX = await import('xlsx');

  const bstr = event.target.result;
  const wb = XLSX.read(bstr, { type: 'binary' });
  const wsname = wb.SheetNames[0];
  const ws = wb.Sheets[wsname];

  const data = XLSX.utils.sheet_to_json(ws, { header: 1 }) as AOA;
  let spreadData: string[] = [];

  data.forEach((row) => {
    spreadData = [...spreadData, ...row];
  });

  spreadData = spreadData.filter((tag) => tag !== null && tag);

  spreadData.forEach((tag, index) => {
    spreadData[index] = tag?.toString();

    if (spreadData[index].length > 30) {
      spreadData[index] = spreadData[index].substring(0, 30);
    }
  });

  return spreadData;
}
